import { Transition } from "@headlessui/react";
import {useTranslation} from "react-i18next";
import {Breadcrumb} from "./form/Breadcrumb";
import {FormHeading} from "../../shared/components/Typograhy";

export default function Question({ question, onClickYes, onClickNo }) {
  const { t } = useTranslation();

  return (
    <Transition
      as="div"
      appear={true} //THIS will make the transition run everytime the component is rendered
      show={true}
      enter="transition-all duration-300"
      enterFrom="transform translate-x-full"
      enterTo="transform translate-x-0"
      leave="transition-all duration-300"
      leaveFrom="transform translate-x-0"
      leaveTo="transform translate-x-full"
      className=""
    >
      <Breadcrumb />

      <FormHeading title={question} />
      <div
        className={
          "mx-auto my-16 flex w-[200px] justify-between text-3xl font-bold"
        }
      >
        <div
          className={
            "text-orange-600 underline underline-offset-4 hover:cursor-pointer hover:text-orange-400"
          }
          onClick={onClickYes}
        >
          {t('booking.yes')}
        </div>
        <div
          className={
            "text-orange-600 underline underline-offset-4 hover:cursor-pointer hover:text-orange-400"
          }
          onClick={onClickNo}
        >
          {t('booking.no')}
        </div>
      </div>
    </Transition>
  );
}
